import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { INoItemsOptions } from '../feed/feed.interface';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  public emptyTabMessage = new BehaviorSubject<INoItemsOptions>({});
}
